import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import FilterList from "@mui/icons-material/FilterList"
import {useEffect, useState} from "react";
import {Select2Popout} from "../../../misc/Select2";
import {api} from "../../../api/API";
import {Option} from "../../../misc/scroller/Table";
import {SmallGreyButton} from "../../../misc/SmallGreyButton";
import {Button} from "@mui/material";
import {projectLabel, ProjectListMode} from "../../../api/Projects";
import {useQueryParam} from "../../project/quote/pricing/QueryParam";
import {useSyncedRef} from "../../../misc/SyncedRef";

export function ProjectFilter(props: {
    value: Option | null;
    onChange(value: Option|null): void;
}) {
    const [anchor, setAnchor] = useState<any>(null);
    const [open, setOpen] = useState(false);

    const [value, setValue] = useQueryParam("proj-d", "");

    const onChangeRef = useSyncedRef(props.onChange)
    const valueRef = useSyncedRef(value);

    useEffect(() => {
        if(valueRef.current) {
            onChangeRef.current(JSON.parse(valueRef.current));
        } else {
            onChangeRef.current(null);
        }
    }, [valueRef, onChangeRef]);

    return (
        <>
            <SmallGreyButton ref={setAnchor} onClick={() => setOpen(true)} startIcon={<FilterList />}>
                {props.value ? props.value.display : "For Project"}
            </SmallGreyButton>
            <Select2Popout open={open} onClear={() => {
                setValue("");
                props.onChange(null)
            }} lookup={async (search) => {
                const list = await api.projects.list({search, offset: 0});
                return list.data.map(l => ({
                    display: projectLabel(l),
                    value: l.id,
                }))
            }} onChange={v => {
                setValue(JSON.stringify(v));
                props.onChange(v);
            }} onClose={() => setOpen(false)} initialValue={""} anchor={anchor} />
        </>
    )
}

export function ProjectChooser(props: {
    value: Option | null;
    mode?: ProjectListMode
    onChange(value: Option|null): void;
}) {
    const [anchor, setAnchor] = useState<any>(null);
    const [open, setOpen] = useState(false);

    return (
        <>
            <Button variant="outlined" ref={setAnchor} color="inherit" onClick={() => setOpen(true)} endIcon={<ArrowDropDown />}>
                {props.value ? props.value.display : "For Project"}
            </Button>
            {open && <ProjectSelectPopover mode={props.mode} anchor={anchor} onChange={props.onChange} onClose={() => setOpen(false)} />}
        </>
    )
}

export function ProjectSelectPopover(props: {
    anchor: any;
    mode?: ProjectListMode
    onChange(value: Option | null): void;
    onClose(): void;
}) {
    return (
        <Select2Popout open onClear={() => props.onChange(null)} lookup={async (search) => {
            const list = await api.projects.list({search, offset: 0, mode: props.mode});
            return list.data.map(l => ({
                display: projectLabel(l),
                value: l.id,
            }))
        }} onChange={props.onChange} onClose={props.onClose} initialValue={""} anchor={props.anchor} />
    )
}

export function ProjectChooserSmall(props: {
    title: string;
    value: Option | null;
    onChange(value: Option|null): void;
}) {
    const [anchor, setAnchor] = useState<any>(null);
    const [open, setOpen] = useState(false);

    return (
        <>
            <SmallGreyButton endIcon={<ArrowDropDown />}
                    ref={setAnchor}
                    onClick={() => setOpen(true)}>
                {props.value ? props.value.display : props.title}
            </SmallGreyButton>
            {open && <ProjectSelectPopover anchor={anchor} onChange={props.onChange} onClose={() => setOpen(false)} />}
        </>
    )
}
